exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-container {\r\n    margin-top: 50px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/layouts/page-layout.component.css
// module id = ../../../../../src/app/core/layouts/page-layout.component.css
// module chunks = 16